import { createSlice } from "@reduxjs/toolkit";
import API from "../../services/ApiService";
import { openNotificationWithIcon } from "../../services/toast";
import { ApiEndPoint } from "../../services/ApiEndpoint";

const initialState = {
  rowData: [],
  currentPage: 1,
  totalEntries: 0,
  pageSize: 10,
  isLoading: false,
  error: null,
};

const entriesSlice = createSlice({
  name: "entries",
  initialState,
  reducers: {
    setRowData(state, action) {
      // state.rowData = action.payload;
      state.rowData = [...action.payload];
    },
    startLoading(state) {
      state.isLoading = true;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    changePage(state, action) {
      state.currentPage = action.payload.page;
      state.pageSize = action.payload.pageSize;
    },
    setTotalEntries(state, action) {
      state.totalEntries = action.payload;
    },
  },
});

export const {
  setRowData,
  startLoading,
  stopLoading,
  setError,
  changePage,
  setTotalEntries,
} = entriesSlice.actions;

export const fetchEntries =
  (buildingId) => async (dispatch, getState) => {
    dispatch(startLoading());
    try {
      const entriesState = getState();
      const currentPage = entriesState.entries.currentPage;
      const limit = entriesState.entries.pageSize;
      const response = await API.get(
        `${ApiEndPoint.editEntriesTable}${buildingId}?skip=${(currentPage - 1) * limit}&limit=${limit}`
      );
      dispatch(setRowData(response?.data?.data?.listing || []));
      dispatch(setTotalEntries(response?.data?.data?.count || 0));
    } catch (error) {
      // Clear stale rows so a failed load never shows the previous screen's data
      // under this screen's heading.
      dispatch(setRowData([]));
      dispatch(setTotalEntries(0));
      dispatch(setError("Error fetching data"));
      openNotificationWithIcon("error", "Error in fetching data");
    } finally {
      dispatch(stopLoading());
    }
  };

export const fetchTableTwo =
  (buildingId) => async (dispatch, getState) => {
    dispatch(startLoading());
    try {
      const entriesState = getState();
      console.log(entriesState, "entriesStateeeeeeeeeeeeeee");
      const currentPage = entriesState.entries.currentPage;
      const limit = entriesState.entries.pageSize;
      const response = await API.get(
        `${ApiEndPoint.tableTwo}${buildingId}?skip=${(currentPage - 1) * limit}&limit=${limit}`
      );
      dispatch(setRowData(response?.data?.data?.listing || []));
      dispatch(setTotalEntries(response?.data?.data?.count || 0));
    } catch (error) {
      // Clear stale rows so a failed load never shows the previous screen's data
      // under this screen's heading.
      dispatch(setRowData([]));
      dispatch(setTotalEntries(0));
      dispatch(setError("Error fetching data"));
      openNotificationWithIcon("error", "Error in fetching data");
    } finally {
      dispatch(stopLoading());
    }
  };

  export const updateEntry = (entryDetails, id, buildingId, currentPage, pageSize) => {
    return async function (dispatch, getState) {
      try {
        await API.put(ApiEndPoint.editEntries + id, entryDetails);
        dispatch(fetchEntries(buildingId, currentPage, pageSize));
        openNotificationWithIcon("success", "Entry updated successfully!");
      } catch (error) {
        openNotificationWithIcon("error", error?.response?.data?.message);
      }
    };
  }

export const deleteEntry = (id, buildingId) => async (dispatch, getState) => {
  try {
    await API.delete(ApiEndPoint.deleteEntries + id);
    // Refetch rather than splicing the row out locally: the local splice left
    // totalEntries counting the deleted row, so the pager offered a page that was
    // now short or empty and the next page's first row never shifted up.
    dispatch(fetchEntries(buildingId));
    openNotificationWithIcon("success", "Entry deleted successfully!");
  } catch (error) {
    dispatch(setError("Error deleting entry"));
    openNotificationWithIcon("error", "Failed to delete entry");
  }
};

export const deleteEntries = (ids, buildingId) => async (dispatch, getState) => {
  try {
    await API.delete(ApiEndPoint.deleteEntries, { data: { ids } }); 
    const updatedData = getState().entries.rowData.filter(
      (entry) => !ids.includes(entry.id)
    );
    dispatch(setRowData(updatedData));
    dispatch(fetchEntries(buildingId));
    openNotificationWithIcon("success", "Entries deleted successfully!");
  } catch (error) {
    dispatch(setError("Error deleting entries"));
    openNotificationWithIcon("error", "Failed to delete entries");
  }
};

export default entriesSlice.reducer;
